import { graphql } from "@/lib/gql/__generated__/gql";

export const RoomNewItem_EditPage_Query = graphql(`
	query RoomNewItem_EditPage($hotelID: ID!, $duplicateRoomID: ID) {
		roomNewItem(hotelID: $hotelID, duplicateRoomID: $duplicateRoomID) {
			id
			hotelID
			roomID
			inSale
			isNotDiscountTarget
			isDormitoryType
			isShowStockPreview
			availablePlanIDs
			maxRoomNum
			capacityPeopleMaximum
			capacityAdultMaximum
			capacityKidsMaximum
			isKidsUnavailable
			kidsPolicy {
				kidsMaxAge
				kidsDiscountType
				ratio
				static {
					currencyType
					amount
				}
			}
			name
			catchCopy
			description
			mainKeyVisual {
				bucket
				key
				region
				mimeType
				fileName
			}
			keyVisuals {
				bucket
				key
				region
				mimeType
				fileName
			}
			article {
				bucket
				key
				region
				mimeType
				fileName
			}
			articleTitle
			saleTypeForPlan
			requiredPrepMillisecond
			amenities
			beds {
				bedType
				bedNum
			}
			roomSize
			overSiteControllerPeopleNum {
				prices {
					upperNum
					price {
						currencyType
						amount
					}
				}
				availableWeekDays
			}
			isExtendSiteControllerPeopleNum
			address {
				nationality
				postalCode
				state
				pref
				city
				town
				other
			}
			geoLocation {
				lat
				lon
			}
		}
		hotelPolicy(hotelID: $hotelID) {
			amenities
		}
		hotelPolicy(hotelID: $hotelID) {
			requiredPrepMillisecond
		}
		planList(hotelID: $hotelID) {
			id
			hotelID
			plans {
				planID
				name
				id
			}
			secrets {
				planID
				name
				id
			}
		}
		discountList(hotelID: $hotelID) {
			id
			ordinary {
				discountID
				id
				name
				hotelID
				isRoomDiscountEligible
			}
		}
	}
`);
